<template>
  <vx-card>
    <validation-observer ref="validator" #default="{valid}">
      <b-form
        :class="[inline ? 'gap-2 items-center' : '']"
        :inline="inline"
        @submit.prevent="addDestination"
        @reset.prevent="clearForm"
        @reset="onReset">

        <validation-provider
          #default="validationContext"
          :name="$t('document_destination_name')"
          rules="required"
          class="flex-grow"
          slim>
          <b-form-group
            id="input-group-1"
            :label="$t('document_destination_name')"
            label-for="document_destination_name">
            <b-form-input
              id="document_destination_name"
              v-model="destination.name"
              :placeholder="$t('document_destination_name')"
              class="required">
            </b-form-input>
            <b-form-invalid-feedback :class="[{'absolute': inline}]">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <!-- E-mail-->
        <validation-provider
          #default="validationContext"
          :name="$t('document_destination_email')"
          rules="required|email"
          class="flex-grow"
          slim>
          <b-form-group
            id="input-group-1"
            :label="$t('document_destination_email')"
            label-for="document_destination_email">
            <b-form-input
              id="document_destination_email"
              type="email"
              v-model="destination.email"
              :placeholder="$t('document_destination_email')"
              class="required">
            </b-form-input>
            <b-form-invalid-feedback :class="[{'absolute': inline}]">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <div class="flex flex-row justify-end gap-4">
          <b-button
            v-permission="`documents.edit`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="px-1"
            variant="outline-primary"
            @click="addDestination"
            :disabled="!valid">
            <feather-icon
              icon="PlusIcon"
              class="mr-50"/>
            <span class="align-middle">{{ $t('add') }}</span>
          </b-button>
           <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="px-1"
            variant="outline-primary"
            @click="$bvModal.show('search-contact')">
            <b-icon-search class="mr-50"/>
            <span class="align-middle">{{ $t('document_destination_search_contact') }}</span>
          </b-button>
        </div>
      </b-form>
    </validation-observer>

  <div class="vs-row w-full pt-2">
    <grid
        ref="grid-destination"
        v-if="service"
        :hide_actions="false"
        :service="service"
        :route_grid_path="`/${id}/destinations/grid`"
        route_name="documents"
        :column_formats="{
          created_at: (val) => {
            return $utils.format.date(val)
          },
          dispatched_at: (val) => {
            return $utils.format.date(val)
          },
          status : (val) =>{
            return ''+val.label
          }
        }"
        :css_formats="{
          status: (val) => {
            return 'text-'+val.color
          }
        }"
      >
        <template v-slot:actions="actions">
          <feather-icon
            v-permission="`documents.edit`"
            v-tooltip="'Enviar ao destinatário'"
            v-if="canDispatchDestination(actions.row)"
            icon="SendIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            @click="dispatchDestination(actions.row.id)"/>
          <feather-icon
            v-permission="`documents.edit`"
            v-tooltip="'Remover destinatário'"
            v-if="canDeleteDestination(actions.row)"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            @click="deleteDestination(actions.row.id)"/>
        </template>
      </grid>
      <div class="flex flex-row justify-end gap-4">
        <b-button v-permission="`documents.edit`"
                  variant="warning"
                  @click="dispatch">
              <feather-icon icon="SendIcon" class="mr-50"/>
                  {{ $t('action.send_pending') }}
        </b-button>
        <b-button @click="goBack" variant="outline-secondary">Voltar</b-button>
      </div>
      <!-- Pop contact-->
      <calendar-contact-popup @selected="addContactList"/>
  </div>
  </vx-card>
</template>

<script>

import SelectSuggestion from '@/components/SelectSuggestion.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, email } from '@validations'
import standard from '@/services/standard'
import { debounce } from 'lodash'


import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BIconLink45deg,
  BIconClipboard,
  BIconCheck,
  BIconX,
  BIconExclamationTriangle,
  BIconSearch,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue'

import DocumentService from '@/services/api/DocumentService'
import CalendarContactPopup from '../calendar/calendar-event-handler/CalendarContactPopup.vue'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    SelectSuggestion,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BButton,
    BIconLink45deg,
    BIconClipboard,
    BIconCheck,
    BIconX,
    BIconExclamationTriangle,
    BIconSearch,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    CalendarContactPopup,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    destination: {
      name: '',
      email: ''
    },
    service: null,
    required, email, min
  }),
  beforeMount() {
    this.updateGrid()

    //this.$root.$on('missive-dispatched', this.updateGrid)
  },
  beforeDestroy() {
    //this.$root.$off('missive-dispatched', this.updateGrid)
  },
  methods: {
    updateGrid(){
      const grid = this.$refs['grid-destination']
      if (grid) {
       grid.fetchGridData()
      }
    },
    goBack() {
      this.$router.push({
        name: 'document-index'
      })
    },
    addContactList(contactList = null){
      if (contactList && this._.isArray(contactList) && contactList.length > 0) {
        let destinations = []

        contactList.forEach(
            (contact) => destinations.push({name: contact.name, email: contact.email})
        )

        this.addDocumentDestination(destinations)
      }
    },
    addDestination() {
      const destinations = [this.destination]

      this.addDocumentDestination(destinations)
    },

    addDocumentDestination(destinations) {
      this.$vs.loading()
      if (this.id) {
        this.service.addEmailDestination(this.id, destinations).then(
          response => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            this.canDispatch()
            this.clearForm()
          },
          error => {
            this.notifyError(this.$vs, `Não foi possível adicionar o(s) destinatário(s)!`)
          }
        ).finally(
          () => {
            this.$vs.loading.close()
            this.updateGrid()
          }
        )
      }
    },
    clearForm(){
      this.destination.name = ''
      this.destination.email = ''
    },
    deleteDestination(id) {
      console.log('to delete destination', id)
      this.$vs.loading()
      this.service.deleteDestination(this.id, id).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.updateGrid()
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
        }
      ).finally(
          () => {
            this.$vs.loading.close()

          }
        )
    },
    dispatchDestination(id) {
      console.log('To dispatch destination', id)
      this.$vs.loading()
      this.service.dispatchDestination(this.id, id).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.updateGrid()
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
          this.updateGrid()
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    },

    canDispatchDestination(destination) {
      return true
    },
    canDeleteDestination(destination) {
      const onError = destination.status === 'ER'
      const onUk = destination.status === 'UK'
      const onPending = destination.status === 'PD'

      return onError || onUk ||onPending
    },
    canDispatch() {
      const grid = this.$refs['grid-destination']
      if(grid){
        const data = grid.model ? grid.model.data : null;
        if(data && data.length > 0){
          const documentDestination = data[0]
          const count = documentDestination.document.pending_dispatches_count
          return count > 0
        }
        return false
      }
      return false
    },
    dispatch() {
      if (!this.canDispatch()) {
        this.notifyWarning(this.$vs, "Não há envio pendentes para esse(s) documento(s).")
        return
      }

      this.$vs.loading()
      this.service.dispatch(this.id).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('document.messages.envio_pendente_disparado'), 9000)
          this.updateGrid();
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },

  },
  computed: {
    validateDestinationForm(){
      return (
        !this.isEmpty(this.destination.name) &&
        !this.isEmpty(this.destination.email))
    }
  },
  beforeMount() {
    this.service = DocumentService.build(this.$vs)
  },
}
</script>


<style lang="scss" scoped>
  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
